export default {"src":"/_next/static/media/heart-fill.4363a83d.svg","height":968,"width":968,"blurWidth":0,"blurHeight":0};